import { makeTintingRequest } from "../makeTintingRequest";

import { UpdatePastaPriceResponse } from "./updatePastaPrice.typed";

export const updatePastaPrice = async (
  pastaId: string,
  newPastaPrice: number
) => {
  return await makeTintingRequest<UpdatePastaPriceResponse[]>({
    url: `/v1/pasta/${pastaId}`,
    method: "PATCH",
    data: {
      price: newPastaPrice,
    },
  });
};
